import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=6567b0dc&scoped=true&"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567b0dc",
  null
  
)

export default component.exports